module.exports = __webpack_public_path__ + "img/logo.91d3335a.png";